<template>
  <v-app class="survey-container">
    <!-- Top Banner -->
    <v-layout wrap class="no-grow">
      <v-flex xs12>
        <div class="top-gray">
          <div class="left">
            <img
              src=""
              width="319"
              alt="Eagle Case Assignment"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>

    <!--Header -->
    <v-layout wrap class="no-grow">
      <v-flex xs12>
        <div class="blue-bar">
          <h1
          >Welcome </h1>
        </div>
      </v-flex>
    </v-layout>

    <!-- Main Contents: Forgot Password -->
    <v-layout wrap class="page-body bg-light-blue">
      <v-flex xs4 class="flex-vert-ctr" justify-center>
        <div class="sign-in-box">
          <v-form>
            <v-layout wrap>
              <v-flex xs12>
                <h2>Enter email or username to reset your password<span class="nyi" /></h2>
                <div v-if="error" style="color:red;">Username or Email does not exist</div>
                <div v-if="emailed" style="color:green;">Check Your Email</div>
              </v-flex>
              <v-flex class="logo-center" xs4>
                <img src="" alt="Eagle logo" width="100px" />
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  solo
                  class="log-in-fields"
                  placeholder="UserName or Email"
                  v-model="UserNameOrEmail"
									density="compact"
                />
                <v-layout>
                  <v-flex>
                    <v-btn
                      normal
                      :loading="isLoading"
                      :disabled="!UserNameOrEmail"
                      class="blue-button"
                      @click="forgotPassword"
                    >Submit</v-btn>
                    <v-btn normal :loading="isLoading" class="blue-button" @click="cancel">Cancel</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { authService } from "@/services/authService.js";
import router from "@/router";

export default {
  name: "forgotpassword",
  data() {
    return {
      username: "",
      UserNameOrEmail: null,
      isLoading: false,
      show: false,
      error: false,
      emailed: false
    };
  },
  methods: {
    forgotPassword() {
      this.$data.isLoading = true;
      let me = this;
      //const claims = authTokenService.getClaims();
      authService
        .forgotPassword(this.$data.UserNameOrEmail)
        .then(function(response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          me.$data.emailed = true;
          me.$data.error = false;
        })
        .catch(function(response) {
          console.log("Test handle error in component");
          me.$data.isLoading = false;
          me.$data.error = true;
          me.$data.emailed = false;
        });
    },
    cancel() {
      router.push({ name: "login" });
    }
  }
};
</script>

<style scoped>
.center {
  text-align: center;
}
.login-container {
  border-radius: 5px;
  background-color: white;
  border: 1px solid #13314f;
}

.main-title {
  color: #313b52;
  font-family: Georgia, Times New Roman, Times, serif;
  font-size: 25px;
}
.sign-in-title-outer {
  padding-top: 60px;
}
.top-title-left-border {
  border-left: 1px solid #969696;
}
.sign-in-sub-title {
  font-family: Georgia, Time New Roman, Times, Serif;
  color: #313b52;
  font-size: 21px;
  line-height: 40px;
  font-weight: bold;
  margin: 0 0 11px 0;
}
.sign-in-sub-title-right {
  font-family: Georgia, Time New Roman, Times, Serif;
  color: #313b52;
  font-size: 40px;
  line-height: 59px;
  margin: 0 0 11px 0;
}
.content-space {
  padding: 49px 23px;
  font-family: Arial, Helvetica, san-serif;
  font-size: 1em;
  line-height: 1.8125em;
  color: #5b5853;
}
.left {
  text-align: left;
  margin-left: 2%;
}
h1 {
  margin: 10px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-family: Calibri, Georgia, Time New Roman, Times, Serif;
  color: white;
  font-size: 30px;
  line-height: 40px;
  font-weight: normal;
  margin: 0 0 11px 0;
}
.contents-pane {
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: -5%;
  background-color: #f2f7fa;
  padding: 3%;
  text-align: left;
  border-style: solid;
  border-width: 0px 0px 0px 15px;
  border-color: #365f8d;
  font-size: 11pt;
  color: black;
}
.logo-center {
  margin-top: 0%;
  margin-right: 0%;
  text-align: center;
}
.log-in-fields {
  margin-bottom: -15px;
  width: 275px;
}
.log-in-fields :deep(input) {
  text-align: left;
}
.indent {
  margin-left: 3%;
}

.nyi {
  display: inline-block;
  margin-top: 8px;
}

</style>
